<app-cover-uploader
  [formControl]="control"
  [url]="coverUrl()"
  [thumbnailUrl]="thumbnailUrl()"
  [uploadLabel]="'Ajouter une photo de couverture'">
</app-cover-uploader>
